import { useState } from 'react'
import AdminHeader from './AdminHeader.js'
import { CALCULATE_RATE, UPLOAD_RATES_MUTATION } from '../graphql/Query/Advertise.js';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ADD_PINCODE_DATA_OF_FRANCHISE } from '../graphql/Mutation/Advertise.js';
import { FOREIGN_EXCEL_FILE_UPLOAD } from '../graphql/Mutation/ExcelFileUpload.js';
import { toast } from 'react-toastify';
import SpinLoader from '../components/SpinLoader.js';

const AdminForeignPriceListExcel = () => {
    const [category, setCategory] = useState("");
    const [description, setDescription] = useState("");
    const [file, setFile] = useState(null);

    const [calculateRate, { data: calculateRateData }] = useLazyQuery(CALCULATE_RATE);
    const [generateExcelUploadUrl, { loading: sheetUploadLoading }] = useMutation(FOREIGN_EXCEL_FILE_UPLOAD);
    // const [uploadTariffSheet] = useMutation(UPLOAD_SHEET);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadRates, { loading: ratesLoading }] = useMutation(UPLOAD_RATES_MUTATION);
    const [uploadPincode, { loading: pincodeLoading }] = useMutation(ADD_PINCODE_DATA_OF_FRANCHISE);
    const [uploadType, setUploadType] = useState('rates');
    const [uploadMessage, setUploadMessage] = useState('');
    const [uploadErrors, setUploadErrors] = useState([]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!selectedFile) {
            setUploadMessage('Please select an Excel file to upload.');
            return;
        }

        try {
            let response;
            if (uploadType === 'rates') {
                response = await uploadRates({ variables: { file: selectedFile } });
                const { success, message, uploadedCount, errors } = response.data.uploadRates;
                setUploadMessage(message);
                setUploadErrors(errors || []);
            } else {
                response = await uploadPincode({ variables: { file: selectedFile } });
                const { success, message, uploadedCount, errors } = response.data.uploadPincodeData;
                setUploadMessage(message);
                setUploadErrors(errors || []);
            }


        } catch (e) {
            setUploadMessage(`Upload failed: ${e.message}`);
            setUploadErrors([]); // Clear any previous errors
        }
    };

    const handleExcelUpload = async (file, category, description) => {
        try {
            // Step 1️⃣: Call GraphQL mutation to get presigned URL + save metadata
            const { data } = await generateExcelUploadUrl({
                variables: {
                    input: {
                        fileName: file?.name,
                        fileType: file?.type,
                        category,
                        description,
                    },
                },
            });

            const uploadUrl = data?.generateExcelUploadUrl?.uploadUrl;
            const fileData = data?.generateExcelUploadUrl?.file;

            if (!uploadUrl) {
                toast.error("Failed to get upload URL");
                return;
            }

            // Step 2️⃣: Upload Excel file directly to S3
            const response = await fetch(uploadUrl, {
                method: "PUT",
                headers: { "Content-Type": file?.type },
                body: file,
            });

            if (!response?.ok) {
                toast.error("Excel file upload failed!");
                return;
            }
            toast.success("Excel file uploaded successfully!");
        } catch (error) {
            toast.error(error?.message || "Something went wrong during upload");
        }
    };
    const handleUploadClick = async () => {
        if (!file) return toast.warn("Please select an Excel file");
        if (!category) return toast.warn("Please enter a category");
        if (!description) return toast.warn("Please enter a description");

        await handleExcelUpload(file, category, description);
        setCategory("");
        setDescription("");
        setFile(null);
    };
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setUploadMessage('');
        setUploadErrors([]);
    };

    return (
        <div>
            <AdminHeader />
            <div className="p-6 border rounded-xl bg-white shadow-lg space-y-4">
                <h2 className="text-xl font-semibold mb-2">📤 Upload Excel Sheet</h2>

                {/* Category Input */}
                <div>
                    <label className="block font-medium mb-1">Category</label>
                    <input
                        type="text"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        placeholder="e.g. E-commerce, Textile, Non-Edible"
                        className="w-full border rounded-md p-2 focus:ring focus:ring-blue-200"
                    />
                </div>

                {/* Description Input */}
                <div>
                    <label className="block font-medium mb-1">Description</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter a short description"
                        className="w-full border rounded-md p-2 focus:ring focus:ring-blue-200"
                    />
                </div>

                {/* File Input */}
                <div>
                    <label className="block font-medium mb-1">Excel File</label>
                    <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={(e) => setFile(e.target.files[0])}
                        className="w-full border rounded-md p-2"
                    />
                </div>

                {/* Upload Button */}
                <button
                    onClick={handleUploadClick}
                    className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-all"
                >
                    Upload Excel {sheetUploadLoading && <SpinLoader />}
                </button>
            </div>
            <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                <h2>Upload Excel Sheet</h2>

                <label>Upload Type:</label>
                <select value={uploadType} onChange={(e) => setUploadType(e.target.value)} style={{ marginBottom: '10px' }}>
                    <option value="rates">International Rates</option>
                    <option value="pincode">Gujarat Pincode Data</option>
                </select>

                <form onSubmit={handleSubmit}>
                    <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                    <button type="submit" disabled={(ratesLoading || pincodeLoading) || !selectedFile} style={{ marginLeft: '10px' }}>
                        {(ratesLoading || pincodeLoading) ? 'Uploading...' : 'Upload'}
                    </button>
                </form>

                {uploadMessage && (
                    <div style={{ marginTop: '20px', padding: '10px', border: '1px solid', borderColor: uploadErrors.length === 0 ? 'green' : 'red', backgroundColor: uploadErrors.length === 0 ? '#e6ffe6' : '#ffe6e6' }}>
                        <p><strong>Status:</strong> {uploadMessage}</p>
                        {uploadErrors.length > 0 && (
                            <div>
                                <p>Errors:</p>
                                <ul style={{ color: 'red' }}>
                                    {uploadErrors.map((err, index) => (
                                        <li key={index}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {/* <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                <h2>Upload Courier Rates (Document, SKYNET, NORMAL)</h2>
                <p>Please upload the Excel sheet named `SKYD_NORMAL_Document_Rates.xlsx`.</p>
                <form onSubmit={handleSubmit}>
                    <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                    <button type="submit" disabled={loading || !selectedFile} style={{ marginLeft: '10px' }}>
                        {loading ? 'Uploading...' : 'Upload Rates'}
                    </button>
                </form>

                {uploadMessage && (
                    <div style={{ marginTop: '20px', padding: '10px', border: '1px solid', borderColor: data?.uploadRates?.success ? 'green' : 'red', backgroundColor: data?.uploadRates?.success ? '#e6ffe6' : '#ffe6e6' }}>
                        <p><strong>Status:</strong> {uploadMessage}</p>
                        {data?.uploadRates?.uploadedCount !== undefined && (
                            <p>Uploaded entries: {data.uploadRates.uploadedCount}</p>
                        )}
                        {uploadErrors.length > 0 && (
                            <div>
                                <p>Errors:</p>
                                <ul style={{ color: 'red' }}>
                                    {uploadErrors.map((err, index) => (
                                        <li key={index}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}

                {error && (
                    <div style={{ marginTop: '20px', color: 'red' }}>
                        <p>An unexpected error occurred: {error?.message}</p>
                    </div>
                )}
            </div> */}
        </div>
    )
}

export default AdminForeignPriceListExcel
